<template>
	<div class="traffic-psychology-page">
		<Head />
		<main class="traffic-main">
			<section class="hero-section section-py">
				<div class="container-custom hero-grid">
					<div class="fade-in">
						<div class="hero-badge">道路交通安全 · 心理闭环管理</div>
						<h1>交通驾驶员心理测评解决方案</h1>
						<p class="hero-tagline">全周期闭环管理，提升道路交通安全管控效能</p>
						
					</div>
					<div class="hero-image-wrap fade-in">
						<img src="https://picsum.photos/900/560?random=72" alt="交通驾驶员心理测评解决方案">
					</div>
				</div>
			</section>

			

			<section id="positioning-goal" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>系统定位与建设目标</h2>
						<div class="title-underline"></div>
						<p>精准定位 · 科学管控 · 安全护航</p>
					</div>
					<div class="two-grid">
						<div class="card card-hover">
							<h3 class="gradient-text">系统定位：全周期覆盖</h3>
							<p>面向交通管理部门、运输企业（客运/货运/网约车）及企事业单位驾驶队伍，提供从入职到离职的全周期驾驶员心理健康管理服务。</p>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">建设目标：闭环管控体系</h3>
							<p>落实道路交通安全心理管控要求，构建“岗前测评—日常监测—风险预警—在岗评估—离岗复盘”的闭环体系，从源头降低心理安全风险。</p>
						</div>
					</div>
				</div>
			</section>

			<section id="core-needs" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>核心需求</h2>
						<div class="title-underline"></div>
					</div>
					<div class="two-grid">
						<div class="card card-hover">
							<h3 class="gradient-text">核心需求（一）</h3>
							<div class="stack-item">
								<h4>合规性保障</h4>
								<ul class="desc-list">
									<li>符合《道路交通安全法》及《道路运输驾驶员管理规定》等法规要求</li>
									<li>严格执行新驾驶员上岗前72小时内初筛机制</li>
									<li>建立驾驶员一人一档，测评数据留存符合行业监管规范</li>
								</ul>
							</div>
							<div class="stack-item">
								<h4>数据安全防护</h4>
								<ul class="desc-list">
									<li>采用内网/专网隔离部署，确保物理环境安全</li>
									<li>数据全程加密传输，操作全流程留痕，可追溯</li>
									<li>实施分级权限管控，严格保护驾驶员个人隐私与心理数据</li>
								</ul>
							</div>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">核心需求（二）</h3>
							<div class="stack-item">
								<h4>实用性与高效落地</h4>
								<ul class="desc-list">
									<li>支持批量测评与离线/在线双模式作答，适配多场景</li>
									<li>多重防作弊机制：人脸核验、答题时长校验、IP锁定</li>
									<li>自动生成标准化报告，风险预警一键推送，提升效率</li>
								</ul>
							</div>
							<div class="stack-item">
								<h4>专业性与精准评估</h4>
								<ul class="desc-list">
									<li>内置交通场景专属心理量表，精准覆盖核心维度</li>
									<li>评估维度涵盖情绪稳定性、风险感知、应激反应等</li>
									<li>适配营运、非营运及特种车辆驾驶员的差异化需求</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section id="function-modules" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>系统功能模块</h2>
						<div class="title-underline"></div>
						<p>专业量表 · 智能适配 · 便捷测评</p>
					</div>
					<div class="highlight-card card card-hover">
						<div class="goal-grid-lite">
							<div v-for="item in moduleSummary" :key="item.title" class="goal-mini">
								<div class="goal-mini-title">{{ item.title }}</div>
								<p>{{ item.desc }}</p>
							</div>
						</div>
					</div>
					<div class="three-grid module-grid">
						<div v-for="item in modulesDetail" :key="item.title" class="card card-hover">
							<h3 class="gradient-text">{{ item.title }}</h3>
							<ul class="desc-list">
								<li v-for="line in item.points" :key="line">{{ line }}</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section id="scales" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>标配量表清单与分述</h2>
						<div class="title-underline"></div>
						<p>全面覆盖 · 精准评估</p>
					</div>
					<div class="three-grid">
						<div v-for="item in scaleGroups" :key="item.title" class="card card-hover">
							<h3 class="gradient-text">{{ item.title }}</h3>
							<ul class="desc-list">
								<li v-for="line in item.items" :key="line">{{ line }}</li>
							</ul>
						</div>
					</div>
					<div class="two-grid mt-18">
						<div class="card card-hover">
							<h3 class="gradient-text">交通专用核心量表分述</h3>
							<ul class="desc-list">
								<li>驾驶心理适配性综合量表：评估认知能力、情绪稳定性与性格特征，判断岗位适配性</li>
								<li>道路驾驶风险感知评估量表：评估风险识别、判断与应对能力，预测安全驾驶行为</li>
								<li>应激反应与应急处置能力量表：测试突发状况下反应速度、情绪控制与应急技巧</li>
								<li>驾驶愤怒情绪与冲动控制量表：测量愤怒频率强度及冲动行为自我控制能力</li>
								<li>长途驾驶疲劳心理状态量表：评估疲劳程度、注意力水平与心理状态变化</li>
							</ul>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">通用与特殊场景量表分述</h3>
							<ul class="desc-list">
								<li>综合症状筛查（SCL-90）：全面筛查心理症状，评估整体心理健康水平</li>
								<li>情绪状态评估（SAS/SDS）：精准评估焦虑和抑郁水平，识别情绪异常风险</li>
								<li>冲动倾向评估：通过冲动性人格量表评估冲动行为倾向</li>
								<li>特定职业群体适配：针对危化品运输、客运服务等岗位定制评估维度</li>
								<li>事故后心理干预：针对交通事故后的心理创伤提供专业评估工具</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section id="business-flow" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>业务流程</h2>
						<div class="title-underline"></div>
					</div>
					<div class="three-grid">
						<div class="card card-hover">
							<h3 class="gradient-text">岗前适配测评</h3>
							<ul class="number-plain">
								<li>批量测评与初筛：新驾驶员上岗/换岗前72小时内完成测评，系统自动初筛风险等级</li>
								<li>专项评估与访谈：高风险人员暂停上岗，由测评师一对一访谈和专项评估</li>
								<li>纳入管理与建档：合格人员纳入常规管理体系，建立“一人一档”电子档案</li>
							</ul>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">日常动态监测</h3>
							<ul class="desc-list">
								<li>基础监测：按季度或月度开展全员普测，建立常态化监测机制</li>
								<li>重点监测：针对违法违规或事故人员，在1周内启动专项加测</li>
								<li>特殊时段：重大节假日或恶劣天气前开展专项心理状态测评</li>
							</ul>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">风险分级与离岗评估</h3>
							<ul class="desc-list">
								<li>蓝级（低风险）：正常管理，定期跟踪观察</li>
								<li>黄级（中风险）：启动约谈干预，制定改进方案，复查销号</li>
								<li>红级（高风险）：立即暂停上岗，实施专业干预，评估恢复</li>
								<li>离岗/转岗：终期测评、报告生成、档案归档，形成闭环</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section id="tech-security" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>技术与安全要求</h2>
						<div class="title-underline"></div>
						<p>INTELLIGENT SECURITY ARCHITECTURE</p>
					</div>
					<ul class="bullet-list card card-hover">
						<li>灵活部署与多端适配：支持内网/专网独立部署，支持断网离线运行，适配PC、安卓平板、车载终端及自助测评机</li>
						<li>安全合规与数据保护：符合等保二级/三级认证要求，遵循《个人信息保护法》，支持与交通管理平台及企业ERP对接</li>
						<li>高性能与专业运维：支持千人同时在线测评，系统响应速度≤3秒，提供7×24小时技术支持和定期升级</li>
					</ul>
				</div>
			</section>

			<section id="implementation" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>实施与保障</h2>
						<div class="title-underline"></div>
						<p>全方位安全保障体系</p>
					</div>
					<div class="three-grid">
						<div class="card card-hover">
							<h3 class="gradient-text">标准化实施流程</h3>
							<p>需求调研 → 系统部署 → 培训赋能 → 试点运行 → 全面推广</p>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">专业人员保障机制</h3>
							<p>配备持证心理测评师，建立“测评—干预—追踪”长效闭环机制。</p>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">无忧售后与运维</h3>
							<p>提供1年免费运维服务，终身技术支持，定期免费升级系统与量表库。</p>
						</div>
					</div>
				</div>
			</section>

			<section id="plan" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>工作推进计划</h2>
						<div class="title-underline"></div>
					</div>
					<div class="table-wrap card card-hover">
						<table class="plan-table">
							<thead>
								<tr>
									<th>阶段</th>
									<th>工作内容</th>
									<th>时间节点</th>
									<th>责任方</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="row in planRows" :key="row.phase">
									<td>{{ row.phase }}</td>
									<td>{{ row.work }}</td>
									<td>{{ row.time }}</td>
									<td>{{ row.owner }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</section>

			<section id="summary" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>总结</h2>
						<div class="title-underline"></div>
					</div>
					<div class="card card-hover">
						<p class="summary-text">本系统专为交通驾驶场景定制，实现驾驶员岗前适配、日常监测、风险预警、心理干预、档案管理全流程闭环，合规安全、专业高效，有效降低驾驶心理风险，提升道路交通安全管控与驾驶队伍管理质效。</p>
						<div class="closing-tags">
							<span>合规安全</span>
							<span>专业高效</span>
							<span>风险管控</span>
							<span>队伍管理</span>
						</div>
					</div>
				</div>
			</section>
			<SiteFooter />
		</main>
	</div>
</template>

<script>
	import Head from '@/components/head/index.vue'
	import SiteFooter from '@/components/footer/index.vue'

	export default {
		name: 'TrafficPsychology',
		components: {
			Head,
			SiteFooter
		},
		data() {
			return {
				tocItems: [{
						num: '01',
						id: 'positioning-goal',
						title: '系统定位与建设目标'
					},
					{
						num: '02',
						id: 'core-needs',
						title: '核心需求'
					},
					{
						num: '03',
						id: 'function-modules',
						title: '系统功能模块'
					},
					{
						num: '04',
						id: 'scales',
						title: '标配量表清单与分述'
					},
					{
						num: '05',
						id: 'business-flow',
						title: '业务流程'
					},
					{
						num: '06',
						id: 'tech-security',
						title: '技术与安全要求'
					},
					{
						num: '07',
						id: 'implementation',
						title: '实施与保障'
					},
					{
						num: '08',
						id: 'plan',
						title: '工作推进计划'
					},
					{
						num: '09',
						id: 'summary',
						title: '总结'
					}
				],
				moduleSummary: [{
						title: '人员与权限管理',
						desc: '构建多级权限体系，实现用户全生命周期管理'
					},
					{
						title: '测评任务管理',
						desc: '灵活创建与派发测评任务，实时追踪进度状态'
					},
					{
						title: '量表库与测评实施',
						desc: '专业量表资源丰富，支持标准化和个性化测评'
					},
					{
						title: '心理档案管理',
						desc: '建立一人一档，全维度记录测评历史和变化轨迹'
					},
					{
						title: '风险预警与处置',
						desc: '智能识别高危风险，构建快速响应和干预机制'
					},
					{
						title: '统计分析与报表',
						desc: '多维数据可视化分析，自动生成专业统计报表'
					}
				],
				modulesDetail: [{
						title: '人员与权限管理',
						points: [
							'三级权限架构：管理员、测评师、操作员精细化分级',
							'人员信息一体化：对接交通管理与企业人事系统，自动同步基础数据',
							'高效账号管理：支持批量创建、密码重置及账号状态管理'
						]
					},
					{
						title: '测评任务管理',
						points: [
							'多场景任务配置：岗前适配、日常监测、重点人员加测和专项评估',
							'全流程防作弊：人脸实名认证、答题时长控制、随机题目排序和异地拦截',
							'智能重测补测：按周期自动触发重测，一键发起补测'
						]
					},
					{
						title: '量表库与测评实施',
						points: [
							'专属量表库：交通专用、通用筛查、特殊场景三大类',
							'多终端适配：PC、车载终端、平板和自助测评机，支持离线作答',
							'智能测评引导：内置操作指引和隐私声明弹窗，提升作答配合度'
						]
					},
					{
						title: '心理档案管理',
						points: [
							'一人一档全维度：整合基础信息、测评报告、访谈记录和干预方案',
							'档案追溯与对比：支持横向和纵向数据对比，呈现变化趋势',
							'档案权限管控：仅授权可查，操作全程留痕'
						]
					},
					{
						title: '风险预警与处置闭环',
						points: [
							'分级预警体系：红、黄、蓝三级阈值自动匹配',
							'多渠道实时触达：系统弹窗、消息推送、短信提醒',
							'处置闭环流程：预警→派发→约谈→整改→复查→销号'
						]
					},
					{
						title: '统计分析与安全审计',
						points: [
							'团体分析与个人报告：按单位、车队、车辆类型自动输出可视化结果',
							'自定义报表：按管理需求导出Excel/Word/PDF',
							'数据安全审计：加密传输、脱敏存储、异地备份、日志追溯'
						]
					}
				],
				scaleGroups: [{
						title: '交通专用核心量表',
						items: [
							'驾驶心理适配性综合量表',
							'道路驾驶风险感知评估量表',
							'驾驶员应激反应与应急处置能力量表',
							'驾驶愤怒情绪与冲动控制量表',
							'长途驾驶疲劳心理状态量表'
						]
					},
					{
						title: '通用筛查必备量表',
						items: [
							'SCL-90（90项症状清单）',
							'SAS（焦虑自评量表）',
							'SDS（抑郁自评量表）',
							'冲动性人格量表（Barratt冲动量表）'
						]
					},
					{
						title: '特殊场景补充量表',
						items: [
							'危化品运输驾驶员风险人格量表',
							'客运驾驶员情绪服务能力量表',
							'未成年/老年驾驶员心理适配量表',
							'交通事故后心理创伤评估量表'
						]
					}
				],
				planRows: [{
						phase: '第一阶段',
						work: '需求调研与方案确认',
						time: '第1-2周',
						owner: '项目组、客户方'
					},
					{
						phase: '第二阶段',
						work: '系统部署与环境搭建',
						time: '第3-4周',
						owner: '技术组'
					},
					{
						phase: '第三阶段',
						work: '人员培训与系统测试',
						time: '第5-6周',
						owner: '培训组、技术组'
					},
					{
						phase: '第四阶段',
						work: '试点运行与问题优化',
						time: '第7-8周',
						owner: '项目组、试点单位'
					},
					{
						phase: '第五阶段',
						work: '全面推广与验收',
						time: '第9-10周',
						owner: '项目组、客户方'
					}
				]
			}
		},
		mounted() {
			this.scrollToHashTarget()
		},
		watch: {
			'$route.hash'() {
				this.scrollToHashTarget()
			}
		},
		methods: {
			scrollToHashTarget() {
				if (!this.$route.hash) {
					return
				}
				this.$nextTick(() => {
					const target = document.querySelector(this.$route.hash)
					if (target) {
						target.scrollIntoView({
							behavior: 'smooth',
							block: 'start'
						})
					}
				})
			}
		}
	}
</script>

<style scoped>
	.traffic-psychology-page {
		min-height: 100vh;
		background: #f9fafb;
		color: #1d2939;
	}

	.traffic-main {
		padding-top: 64px;
	}

	.section-py {
		padding: 64px 0;
	}

	.section-soft {
		background: #f3f7fc;
	}

	.container-custom {
		max-width: 1260px;
		margin: 0 auto;
		padding: 0 20px;
	}

	.section-head {
		max-width: 780px;
		margin: 0 auto 40px;
		text-align: center;
	}

	.section-head h2 {
		margin: 0;
		font-size: clamp(26px, 3.5vw, 42px);
		line-height: 1.3;
	}

	.section-head p {
		margin: 0;
		font-size: 17px;
		line-height: 1.75;
		color: #5f6f82;
	}

	.title-underline {
		width: 66px;
		height: 5px;
		margin: 18px auto;
		border-radius: 999px;
		background: #36b37e;
	}

	.hero-section {
		background: linear-gradient(135deg, rgba(30, 101, 193, 0.07) 0%, rgba(54, 179, 126, 0.07) 100%);
	}

	.hero-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 30px;
		align-items: center;
	}

	.hero-badge {
		display: inline-block;
		padding: 8px 14px;
		margin-bottom: 10px;
		border-radius: 999px;
		font-size: 13px;
		color: #1e65c1;
		background: rgba(30, 101, 193, 0.1);
	}

	.hero-section h1 {
		margin: 0 0 14px;
		font-size: clamp(34px, 5vw, 56px);
		line-height: 1.25;
	}

	.hero-tagline {
		margin: 0 0 12px;
		font-size: 18px;
		font-weight: 600;
		color: #1e65c1;
	}

	.hero-meta {
		margin: 0;
		font-size: 16px;
		line-height: 1.8;
		color: #4b5563;
	}

	.hero-date {
		color: #5f6f82;
	}

	.hero-image-wrap {
		background: #fff;
		padding: 10px;
		border-radius: 16px;
		border: 1px solid #dbe5f0;
		box-shadow: 0 12px 28px rgba(30, 101, 193, 0.15);
	}

	.hero-image-wrap img {
		display: block;
		width: 100%;
		height: auto;
		border-radius: 10px;
	}

	.toc-grid {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 14px;
	}

	.toc-card {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 16px 18px;
		background: #fff;
		border: 1px solid #deebf8;
		border-radius: 14px;
		box-shadow: 0 3px 15px rgba(30, 101, 193, 0.08);
		text-decoration: none;
		color: inherit;
		transition: all 0.35s ease;
	}

	.toc-card:hover {
		transform: translateY(-4px);
		box-shadow: 0 8px 25px rgba(30, 101, 193, 0.16);
	}

	.toc-num {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		background: #1e65c1;
		color: #fff;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		font-size: 13px;
		font-weight: 700;
		flex-shrink: 0;
	}

	.toc-title {
		font-size: 15px;
		font-weight: 600;
		color: #1d2939;
	}

	.two-grid,
	.three-grid {
		display: grid;
		gap: 18px;
	}

	.two-grid {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	.three-grid {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}

	.module-grid {
		margin-top: 18px;
	}

	.card {
		background: #fff;
		border: 1px solid #deebf8;
		border-radius: 14px;
		padding: 22px 18px;
		box-shadow: 0 3px 15px rgba(30, 101, 193, 0.08);
	}

	.card-hover {
		transition: all 0.35s ease;
	}

	.card-hover:hover {
		transform: translateY(-6px);
		box-shadow: 0 8px 25px rgba(30, 101, 193, 0.16);
	}

	.gradient-text {
		margin: 0 0 14px;
		font-size: 22px;
		background: linear-gradient(90deg, #1e65c1, #36b37e);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
		color: transparent;
	}

	.highlight-card {
		padding: 20px;
	}

	.goal-grid-lite {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 12px;
	}

	.goal-mini {
		padding: 14px;
		border-radius: 12px;
		border: 1px solid #e1eaf5;
		background: #fff;
	}

	.goal-mini-title {
		display: inline-block;
		margin-bottom: 8px;
		padding: 4px 10px;
		border-radius: 999px;
		font-size: 12px;
		font-weight: 700;
		color: #1e65c1;
		background: rgba(30, 101, 193, 0.1);
	}

	.goal-mini p {
		margin: 0;
		font-size: 14px;
		line-height: 1.65;
		color: #5f6f82;
	}

	.stack-item {
		margin-bottom: 14px;
		padding-left: 12px;
		border-left: 4px solid #1e65c1;
	}

	.stack-item:last-child {
		margin-bottom: 0;
	}

	.stack-item h4 {
		margin: 0 0 8px;
		font-size: 17px;
	}

	.stack-item p {
		margin: 0;
		font-size: 14px;
		line-height: 1.7;
		color: #5f6f82;
	}

	.desc-list {
		margin: 0;
		padding: 0;
		list-style: none;
	}

	.desc-list li {
		position: relative;
		padding-left: 12px;
		font-size: 14px;
		line-height: 1.75;
		color: #5f6f82;
		margin-bottom: 10px;
	}

	.desc-list li::before {
		content: '•';
		position: absolute;
		left: 0;
		color: #1e65c1;
	}

	.bullet-list {
		margin: 0;
		padding: 18px 22px 18px 36px;
		list-style: none;
	}

	.bullet-list li {
		position: relative;
		font-size: 15px;
		line-height: 1.75;
		color: #374151;
		margin-bottom: 10px;
	}

	.bullet-list li::before {
		content: '•';
		position: absolute;
		left: -14px;
		color: #1e65c1;
		font-weight: bold;
	}

	.number-plain {
		margin: 0;
		padding: 0;
		list-style: none;
		counter-reset: em;
	}

	.number-plain li {
		position: relative;
		padding-left: 28px;
		margin-bottom: 12px;
		font-size: 14px;
		line-height: 1.75;
		color: #5f6f82;
		counter-increment: em;
	}

	.number-plain li::before {
		content: counter(em, decimal-leading-zero);
		position: absolute;
		left: 0;
		top: 0;
		width: 22px;
		font-size: 13px;
		font-weight: 700;
		color: #1e65c1;
	}

	.table-wrap {
		overflow-x: auto;
		padding: 0;
	}

	.plan-table {
		width: 100%;
		min-width: 720px;
		border-collapse: collapse;
		font-size: 14px;
	}

	.plan-table th,
	.plan-table td {
		padding: 12px 14px;
		text-align: left;
		border-bottom: 1px solid #e8eef5;
		vertical-align: top;
	}

	.plan-table th {
		background: #f0f6fc;
		color: #1d2939;
		font-weight: 600;
		white-space: nowrap;
	}

	.plan-table tbody tr:hover {
		background: #fafcfe;
	}

	.summary-text {
		margin: 0 0 18px;
		font-size: 16px;
		line-height: 1.9;
		color: #4b5563;
	}

	.closing-tags {
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
	}

	.closing-tags span {
		padding: 8px 18px;
		border-radius: 999px;
		background: rgba(30, 101, 193, 0.08);
		border: 1px solid rgba(30, 101, 193, 0.18);
		font-size: 14px;
		font-weight: 600;
		color: #1e65c1;
	}

	.mt-18 {
		margin-top: 18px;
	}

	.fade-in {
		animation: fadeIn 0.8s ease-in-out forwards;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(20px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@media (max-width: 992px) {
		.traffic-main {
			padding-top: 56px;
		}

		.section-py {
			padding: 48px 0;
		}

		.hero-grid,
		.two-grid,
		.three-grid,
		.toc-grid,
		.goal-grid-lite {
			grid-template-columns: 1fr;
		}
	}

	@media (max-width: 768px) {
		.container-custom {
			padding: 0 14px;
		}

		.section-py {
			padding: 34px 0;
		}

		.section-head p {
			font-size: 14px;
		}
	}
</style>